import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "segmented-control",
  role: "group",
  "aria-label": "Период"
}
const _hoisted_2 = {
  class: "segmented-control",
  role: "group",
  "aria-label": "Указать период"
}
const _hoisted_3 = {
  key: 0,
  class: "ui-field"
}
const _hoisted_4 = {
  key: 1,
  class: "ui-field"
}
const _hoisted_5 = { class: "ui-field" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "ui-field" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ui-field" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "segmented-control",
  role: "group",
  "aria-label": "Ответственный"
}
const _hoisted_12 = { class: "check-label" }

import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { NativeSelect } from '@/components/ui/select';

import { computed, ref, watch } from 'vue';
import moment from 'moment';

export type PeriodMode = '7' | '30' | '90' | 'overdue' | 'custom';

export interface ExpirationsFilterModel {
  periodMode: PeriodMode;
  withinDays: number | null;
  untilDate: string | null;
  type: 'all' | 'support' | 'module';
  productId: number | null;
  supporterId: number | null;
  mine: boolean;
  hideOverdue: boolean;
}

interface Props {
  model: ExpirationsFilterModel;
  products: Product[];
  companies: Company[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpirationsFilters',
  props: {
    model: {},
    products: {},
    companies: {}
  },
  emits: ["update:model"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const presets = [
  { value: '7' as PeriodMode, label: 'Неделя' },
  { value: '30' as PeriodMode, label: 'Месяц' },
  { value: '90' as PeriodMode, label: 'Квартал' },
  { value: 'overdue' as PeriodMode, label: 'Просрочено' },
  { value: 'custom' as PeriodMode, label: 'Другое' },
];

const typeItems = [
  { title: 'Все типы', value: 'all' },
  { title: 'Поддержка', value: 'support' },
  { title: 'Лицензия', value: 'module' },
];

const todayIso = moment().format('YYYY-MM-DD');
const customKind = ref<'days' | 'date'>(props.model.untilDate ? 'date' : 'days');
const customDays = ref<number>(props.model.withinDays ?? 45);
const customUntil = ref<string>(props.model.untilDate || todayIso);

watch(
  () => props.model,
  (m) => {
    if (m.periodMode === 'custom') {
      if (m.untilDate) {
        customKind.value = 'date';
        customUntil.value = m.untilDate;
      } else if (m.withinDays != null) {
        customKind.value = 'days';
        customDays.value = m.withinDays;
      }
    }
  },
  { deep: true }
);

const productItems = computed(() => props.products.map((p) => ({ title: p.name, value: p.id })));
const supporterItems = computed(() => props.companies.map((c) => ({ title: c.name, value: c.id })));

function emitPatch(patch: Partial<ExpirationsFilterModel>) {
  emit('update:model', { ...props.model, ...patch });
}

function selectPreset(mode: PeriodMode) {
  if (mode === 'overdue') {
    emitPatch({
      periodMode: 'overdue',
      withinDays: null,
      untilDate: null,
      hideOverdue: false,
    });
    return;
  }
  if (mode === 'custom') {
    emitPatch({
      periodMode: 'custom',
      withinDays: customDays.value,
      untilDate: null,
    });
    customKind.value = 'days';
    return;
  }
  emitPatch({
    periodMode: mode,
    withinDays: Number(mode),
    untilDate: null,
  });
}

function emitCustomDays(value: number | string) {
  const days = Number(value);
  if (Number.isNaN(days) || days < 0) return;
  customDays.value = days;
  emitPatch({ periodMode: 'custom', withinDays: days, untilDate: null });
}

function emitCustomDate(value: string) {
  if (!value) return;
  customUntil.value = value;
  emitPatch({ periodMode: 'custom', withinDays: null, untilDate: value });
}

watch(customKind, (kind) => {
  if (props.model.periodMode !== 'custom') return;
  if (kind === 'days') emitCustomDays(customDays.value);
  else emitCustomDate(customUntil.value || todayIso);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "mb-5" }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardContent), { class: "expiration-filters" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (preset) => {
              return _createVNode(_unref(Button), {
                key: preset.value,
                size: "sm",
                variant: __props.model.periodMode === preset.value ? 'secondary' : 'ghost',
                "aria-pressed": __props.model.periodMode === preset.value,
                onClick: ($event: any) => (selectPreset(preset.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(preset.label), 1)
                ]),
                _: 2
              }, 1032, ["variant", "aria-pressed", "onClick"])
            }), 64))
          ]),
          (__props.model.periodMode === 'custom')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: customKind.value === 'days' ? 'secondary' : 'ghost',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (customKind.value = 'days'))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" Дни ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["variant"]),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    variant: customKind.value === 'date' ? 'secondary' : 'ghost',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (customKind.value = 'date'))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Дата ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["variant"])
                ]),
                (customKind.value === 'days')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ui-label" }, "Дней", -1)),
                      _createVNode(_unref(Input), {
                        "model-value": customDays.value,
                        type: "number",
                        min: "0",
                        class: "w-24",
                        "onUpdate:modelValue": emitCustomDays
                      }, null, 8, ["model-value"])
                    ]))
                  : (_openBlock(), _createElementBlock("label", _hoisted_4, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "ui-label" }, "До", -1)),
                      _createVNode(_unref(Input), {
                        "model-value": customUntil.value,
                        type: "date",
                        min: _unref(todayIso),
                        "onUpdate:modelValue": emitCustomDate
                      }, null, 8, ["model-value", "min"])
                    ]))
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("label", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ui-label" }, "Саппортер", -1)),
            _createVNode(_unref(NativeSelect), {
              "model-value": __props.model.supporterId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emitPatch({ supporterId: $event ?? null })))
            }, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Все саппортеры", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supporterItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.value,
                    value: item.value
                  }, _toDisplayString(item.title), 9, _hoisted_6))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          _createElementVNode("label", _hoisted_7, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ui-label" }, "Продукт", -1)),
            _createVNode(_unref(NativeSelect), {
              "model-value": __props.model.productId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emitPatch({ productId: $event ?? null })))
            }, {
              default: _withCtx(() => [
                _cache[14] || (_cache[14] = _createElementVNode("option", { value: null }, "Все продукты", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item.value,
                    value: item.value
                  }, _toDisplayString(item.title), 9, _hoisted_8))
                }), 128))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          _createElementVNode("label", _hoisted_9, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ui-label" }, "Тип", -1)),
            _createVNode(_unref(NativeSelect), {
              "model-value": __props.model.type,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (emitPatch({ type: $event })))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeItems, (item) => {
                  return _createElementVNode("option", {
                    key: item.value,
                    value: item.value
                  }, _toDisplayString(item.title), 9, _hoisted_10)
                }), 64))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Button), {
              size: "sm",
              variant: !__props.model.mine ? 'secondary' : 'ghost',
              "aria-pressed": !__props.model.mine,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emitPatch({ mine: false })))
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" Все ", -1)
              ]))]),
              _: 1
            }, 8, ["variant", "aria-pressed"]),
            _createVNode(_unref(Button), {
              size: "sm",
              variant: __props.model.mine ? 'secondary' : 'ghost',
              "aria-pressed": __props.model.mine,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (emitPatch({ mine: true })))
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode(" Мои ", -1)
              ]))]),
              _: 1
            }, 8, ["variant", "aria-pressed"])
          ]),
          _createElementVNode("label", _hoisted_12, [
            _createVNode(_unref(Checkbox), {
              "model-value": __props.model.hideOverdue,
              disabled: __props.model.periodMode === 'overdue',
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (emitPatch({ hideOverdue: Boolean($event) })))
            }, null, 8, ["model-value", "disabled"]),
            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Скрыть просроченные", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})